import { useState } from 'react';
import { updateProfile } from '../services/profile';

const SIMMER_OPTIONS = [1, 2, 3, 5, 7, 14];

function fmt(ms) {
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export default function ProfilePage({ user, items, simmerDays, onSimmerDaysChange, onSignOut, onBack }) {
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);

  const skippedItems      = items.filter(i => i.status === 'skipped');
  const totalSaved        = skippedItems.reduce((s, i) => s + (i.price || 0), 0);
  const boughtCount       = items.filter(i => i.status === 'bought').length;
  const skipRate          = skippedItems.length + boughtCount > 0
    ? Math.round((skippedItems.length / (skippedItems.length + boughtCount)) * 100)
    : null;

  const memberSince = user.created_at
    ? fmt(new Date(user.created_at).getTime())
    : '—';

  const handleDaysChange = async (days) => {
    if (days === simmerDays) return;
    setSaving(true);
    onSimmerDaysChange(days); // optimistic
    await updateProfile(user.id, { simmer_days: days });
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="profile-page">
      <div className="profile-header">
        <button className="profile-back" onClick={onBack} aria-label="Back">
          ← Back
        </button>
        <h2 className="profile-title">Account</h2>
      </div>

      {/* ── Identity ── */}
      <div className="profile-section">
        <div className="profile-avatar-lg">
          {user.email?.[0]?.toUpperCase() || '?'}
        </div>
        <p className="profile-email">{user.email}</p>
        <p className="profile-since">Member since {memberSince}</p>
      </div>

      {/* ── Savings summary ── */}
      <div className="profile-section">
        <h3 className="profile-section-title">Savings</h3>
        <div className="profile-stats">
          <div className="profile-stat">
            <span className="profile-stat-value">${totalSaved.toFixed(2)}</span>
            <span className="profile-stat-label">All-time saved</span>
          </div>
          <div className="profile-stat">
            <span className="profile-stat-value">{skippedItems.length}</span>
            <span className="profile-stat-label">Items skipped</span>
          </div>
          {skipRate !== null && (
            <div className="profile-stat">
              <span className="profile-stat-value">{skipRate}%</span>
              <span className="profile-stat-label">Impulse control rate</span>
            </div>
          )}
        </div>
      </div>

      {/* ── Simmer duration ── */}
      <div className="profile-section">
        <h3 className="profile-section-title">Simmer time</h3>
        <p className="profile-section-sub">
          Adjust how long you'd like to simmer before deciding.
          {saving && <span className="profile-saving"> Saving…</span>}
          {saved  && <span className="profile-saved"> Saved ✓</span>}
        </p>
        <div className="profile-days-pills">
          {SIMMER_OPTIONS.map(d => (
            <button
              key={d}
              className={`profile-days-pill ${d === simmerDays ? 'active' : ''}`}
              onClick={() => handleDaysChange(d)}
            >
              {d} days
            </button>
          ))}
        </div>
      </div>

      {/* ── Actions ── */}
      <div className="profile-section profile-section--actions">
        <button className="profile-signout" onClick={onSignOut}>
          Sign out
        </button>
        <a
          href="https://github.com"
          className="profile-about-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          About Simmer
        </a>
      </div>
    </div>
  );
}
